import React from 'react';
import Gallery from '@jetshop/ui/Gallery/Gallery';
import { default as Badges } from '@jetshop/ui/ProductList/Badges';
import styled from 'react-emotion';

const Wrapper = styled('div')`
  display: flex;
  flex-direction: column;

  .image-gallery-image > div:last-child {
    margin: 1rem;
  }
`;

export default class ImageContainer extends React.PureComponent {
  render() {
    const { images, className, badges } = this.props;
    return (
      <Wrapper className={className}>
        <Gallery images={images} aspect={'4:3'}>
          <Badges badges={badges} className="badge" />
        </Gallery>
      </Wrapper>
    );
  }
}
